module.exports = __webpack_public_path__ + "img/idea-leader-1.8cbf398b.svg";